module.exports = __webpack_public_path__ + "media/we-wish-you-a-merry-christmas_timothy-infinite.20a46102.mp3";